import { render, staticRenderFns } from "./EsameEcgViewComponent.vue?vue&type=template&id=a4dfa3b2"
import script from "./EsameEcgViewComponent.vue?vue&type=script&lang=js"
export * from "./EsameEcgViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports